import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { trackEvent } from '../lib/adminApi';

const PHONE_NUMBER = '+918317599282';

// Active window in IST: 10:30 AM – 9:35 PM, every day
const START_MINUTES = 10 * 60 + 30;  // 10:30 AM = 630
const END_MINUTES = 21 * 60 + 35;    // 9:35 PM = 1295

// Returns current minutes-since-midnight in IST regardless of the user's TZ.
const getISTMinutesOfDay = () => {
  const now = new Date();
  // IST is UTC+5:30. Convert any browser TZ to IST.
  const istMs = now.getTime() + now.getTimezoneOffset() * 60 * 1000 + (5 * 60 + 30) * 60 * 1000;
  const ist = new Date(istMs);
  return ist.getHours() * 60 + ist.getMinutes();
};

const isWithinCallHours = () => {
  const m = getISTMinutesOfDay();
  return m >= START_MINUTES && m <= END_MINUTES;
};

const CallNowButton = () => {
  const [visible, setVisible] = useState(isWithinCallHours);

  useEffect(() => {
    // Re-check every 60s so the button disappears/appears at the boundary
    // even if the user keeps the tab open across the threshold.
    const id = setInterval(() => setVisible(isWithinCallHours()), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  if (!visible) return null;

  const handleCallClick = () => {
    // Persist event to admin DB
    trackEvent('phone_click', 'floating');
    // Fire Google Ads conversion (uses same gtag, no event_callback needed because
    // tel: links open the native dialer without unloading the page).
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16474493641/u0rxCLHj_7YcEMml0689',
        value: 50.0,
        currency: 'INR',
      });
    }
  };

  return (
    <a
      href={`tel:${PHONE_NUMBER}`}
      onClick={handleCallClick}
      className="call-float-button"
      aria-label="Call O2 Nails Hyd"
      data-testid="call-float-btn"
    >
      <span className="call-open-badge" aria-hidden="true">
        <span className="call-open-dot"></span>
        Open Now
      </span>
      <Phone className="call-float-icon" />
      <span className="call-float-label">Call</span>
    </a>
  );
};

export default CallNowButton;
